import React from "react";
import type { GatsbyBrowser } from "gatsby";
import Root from "./src/layouts/partials/root";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <Root>{element}</Root>;

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({
  prevLocation,
}) => {
  if (window) {
    window.previousLocation = prevLocation;
  }
};
